/**
 * $.uiDrawer() plugin.
 *
 * It is allowed to call several $.uiDrawer() at the same time.
 * Also compatible with using multiple .uiDrawerBottom() at the same time.
 *
 * Options:
 *     position: left|right|top|bottom (default: right)                          - The position where the drawer comes from.
 *     size:     extra-small|small|medium|large|full|500px|50% (default: medium) - Drawer size.
 *
 *     esc:                       boolean (default: true)  - Loses the $.uiDrawer() when press [Escape].
 *     lock_body_scroll:          boolean (default: true)  - When opened, the scroll of the page is blocked.
 *     mobile_fullscreen:         boolean (default: false) - Renders the $.uiDrawer() in full screen on mobile sizes.
 *     disable_content_scroll:    boolean (default: false) - Lag to disable wrapping 'content' in a scrollbar.
 *     fluid:                     boolean (default: false) - Remove fixed height from drawer body. Works correctly only if disable_content_scroll:true.
 *     close_on_avia_before_load: boolean (default: true)  - Close the drawer before starting content loading.
 *
 *     html:     string        - Custom html for $.uiDrawer(). Must contain all UIDrawer.class to work correctly.
 *                               Required if there is no $wrapper, header, content and footer.
 *     $wrapper: jQuery object - Custom jQuery object for $.uiDrawer(). Must contain all uiDrawer.class to work correctly.
 *                               Required if there is no html, header, content and footer.
 *
 *     custom_class:       string (optional)        – Add custom class to .drawer-layout
 *
 *     header_contrast:    boolean (default: false) - Makes the header contrast (dark background, white text).
 *     header_title:       string (optional)        - Title for drawer.
 *     header_description: string (optional)        - Description for drawer. Displayed under title.
 *
 *     content_top: string (optional)       - The string to be added to the content above without paddings.
 *     content_fixed: string (optional) - The string to be added to the content above without paddings. Added outside the scrollbar.
 *     content: string (optional)           - The string to be added to the content. By default wraps in a scrollbar. Use 'disable_content_scroll' to avoid this.
 *
 *     footer: string (optional) - The string to be added to the footer.
 *
 *     button_confirm_text: string (optional) - The text that will be displayed on the confirm button. HTML is allowed.
 *     button_confirm_class: array (optional)
 *
 *     button_cancel_text:  string (optional) - The text that will be displayed on the cancel button. HTML is allowed.
 *     button_cancel_class:  string (optional) - The text that will be displayed on the cancel button. HTML is allowed.
 *     
 *     custom_focus_class: string(optional) - Set focus on custom element supportive focus after open drawer. Default set on the $drawer_body with tabindex=-1.
 *
 *     onButtonConfirmClick(that, event): function - Callback, called when confirm button is clicked. Closes the drawer by default. Control the event to prevent this.
 *     onButtonCancelClick(that, event):  function - Callback, called when cancel button is clicked. Closes the drawer by default. Control the event to prevent this.
 *     onBgClick(that, event):            function - Callback, that will be called when the background is clicked. Closes the drawer by default. Control the event to prevent this.

 *     onOpen(that.$wrapper, that):   function - Callback, which will be called when the $.uiDrawer() is opened.
 *     onClose(that):                 function - Callback, which will be called when the $.uiDrawer() is closes.
 *     onResize(that.$wrapper, that): function - Callback, that will be called when the $.uiDrawer() is resized.
 */
(function ($) {

    var UIDrawer = (function ($) {

        UIDrawer = function (options) {
            var that = this;

            that.AVAILABLE_POSITIONS = ['left', 'right', 'top', 'bottom'];
            that.AVAILABLE_SIZES = ['extra-small', 'small', 'medium', 'large', 'full']; // And also in pixels and percentages

            that.class = {
                position_left: 'drawer-left',
                position_right: 'drawer-right',
                position_top: 'drawer-top',
                position_bottom: 'drawer-bottom',

                position_left_show: 'fadeInLeft',
                position_left_hide: 'fadeOutLeft',
                position_right_show: 'fadeInRight',
                position_right_hide: 'fadeOutRight',
                position_top_show: 'fadeInDown',
                position_top_hide: 'fadeOutUp',
                position_bottom_show: 'fadeInUp',
                position_bottom_hide: 'fadeOutDown',

                fluid: 'fluid',

                size_extra_small: 'extra-small',
                size_small: 'small',
                size_medium: 'medium',
                size_large: 'large',
                size_full: 'full',

                body_locker: 'js-body-locker', // Required to synchronize with other locker-elements on the page (other modals, drawers, etc..)
                wrapper: 'drawer',
                wrapper_mobile_fullscreen: 'drawer-mobile-fullscreen',
                background: 'drawer-background',
                layout: 'drawer-layout',
                body: 'drawer-body',

                header: 'drawer-header',
                header_contrast: 'drawer-header-contrast',
                header_wrapper: 'drawer-header-wrapper',
                header_title: 'drawer-header-title',
                header_description: 'drawer-header-description',
                header_icons: 'drawer-header-icons',
                close_icon: 'drawer-close-icon',

                content_fixed_wrapper: 'drawer-content-fixed-wrapper',
                content_fixed: 'drawer-content-fixed',

                content_wrapper: 'drawer-content-wrapper',
                content: 'drawer-content',
                content_top: 'drawer-content-top',

                footer: 'drawer-footer'
            };

            that.icons = {
                close: '<i class="fab fa-sa-x"></i>'
            };

            //

            that.options = options;
            that.position = (that.options['position'] || 'right');
            that.fluid = (that.options['fluid'] || false);
            that.size = (that.options['size'] || 'medium');
            that.mobile_fullscreen = (that.options['mobile_fullscreen'] || false);
            that.close_on_avia_before_load = (typeof that.options['close_on_avia_before_load'] !== 'undefined') ? that.options['close_on_avia_before_load'] : true;
            that.header_contrast = (that.options['header_contrast'] || false);
            that.custom_class = (that.options['custom_class'] || null);
            that.custom_focus_class = (that.options['custom_focus_class'] || null);

            that.$wrapper = that.__getWrapper();

            if (that.$wrapper && that.$wrapper.length) {
                // DOM
                that.$body = $(document).find('body');
                that.$drawer_background = that.$wrapper.find(that.getSelector('background'));
                that.$drawer_body = that.$wrapper.find(that.getSelector('body'));

                // CONST
                that.esc = (typeof that.options['esc'] === 'boolean' ? that.options['esc'] : true);

                // VARS
                that.lock_body_scroll = (typeof that.options['lock_body_scroll'] === 'boolean' ? that.options['lock_body_scroll'] : true);

                // DYNAMIC VARS
                that.is_visible = false;
                that.is_removed = false;

                // HANDLERS
                that.onBgClick = (that.options['onBgClick'] || false);
                that.onButtonConfirmClick = (that.options['onButtonConfirmClick'] || false);
                that.onButtonCancelClick = (that.options['onButtonCancelClick'] || false);

                that.onOpen = (that.options['onOpen'] || function () {});
                that.onClose = (that.options['onClose'] || function () {});
                that.onResize = (that.options['onResize'] || false);

                // INIT
                try {
                    that.__validateOptions();
                    that.init();
                } catch (e) {
                    $.sa.log('Error drawer init: ' + e.message);
                }

            } else {
                $.sa.log('Error drawer: bad data');
            }
        };

        UIDrawer.prototype.init = function () {
            var that = this;
            // save link on drawer
            that.$wrapper.data('drawer', that);
            //
            that.render();

            // Delay binding close events so that drawer does not close immidiately
            // from the same click that opened it.
            setTimeout(function () {
                that.bindEvents();
            }, 0);
        };

        UIDrawer.prototype.bindEvents = function () {
            var that = this,
                $document = $(document);

            $.sa.$document.on('avia_before_load', function () {
                if (that.close_on_avia_before_load) {
                    that.close();
                }
            });

            // Click on background, default nothing
            that.$wrapper.on('click', that.getSelector('background'), function (event) {
                if (typeof that.onBgClick === 'function') {
                    if (false !== that.onBgClick(that, event)) {
                        that.close();
                    }
                    return false;
                }
                that.close();
            });

            that.$wrapper.on('click', '.js-close-drawer', function (event) {
                event.preventDefault();
                that.close();
            });

            that.$wrapper.on('click', '.js-close', function () {
                that.close();
            });

            that.$wrapper.on('click', '.js-button-confirm', function (event) {
                if (typeof that.onButtonConfirmClick === 'function') {
                    var res = that.onButtonConfirmClick(that, event);
                    if (res === false) {
                        return;
                    }
                }
                that.close();
            });

            that.$wrapper.on('click', '.js-button-cancel', function (event) {
                if (typeof that.onButtonCancelClick === 'function') {
                    that.onButtonCancelClick(that, event);
                }
                that.close();
            });

            that.$wrapper.on('close', function () {
                that.close();
            });

            // Handler for Android back button
            $.sa.$window.on('popstate', function () {
                // that.close();
            });

            if (that.esc) {
                $document.on('keydown', escapeWatcher);

                function escapeWatcher(event) {
                    var is_exist = $.contains(document, that.$wrapper[0]);
                    if (is_exist) {
                        var escape_code = 27;
                        if (event.keyCode === escape_code) {
                            that.close();
                        }
                    } else {
                        if (that.is_removed) {
                            $document.off('keydown', escapeWatcher);
                        }
                    }
                }
            }

            $.sa.$window.on('resize', onResize);

            function onResize() {
                var is_exist = $.contains(document, that.$wrapper[0]);
                if (is_exist) {
                    that.resize();
                } else {
                    if (that.is_removed) {
                        $.sa.$window.off('resize', onResize);
                    }
                }
            }

            // refresh drawer position
            $document.on('refresh', resizeDrawer);

            function resizeDrawer() {
                var is_exist = $.contains(document, that.$wrapper[0]);
                if (is_exist) {
                    that.resize();
                } else {
                    if (that.is_removed) {
                        $document.off('resizeDrawer', resizeDrawer);
                    }
                }
            }
        };

        UIDrawer.prototype.render = function () {
            var that = this;

            try {
                that.show();
            } catch (e) {
                $.sa.log('Error drawer: ' + e.message);
            }

            that.__initContentScrollbar();

            if (that.lock_body_scroll) {
                $.sa.scroll_locker.locked();
                that.$wrapper.addClass(that.class.body_locker);
            }

            that.onOpen(that.$wrapper, that);
        };

        UIDrawer.prototype.resize = function () {
            var that = this;

            that.__setupContentHeight();

            if (that.onResize) {
                that.onResize(that.$wrapper, that);
            }
        };

        UIDrawer.prototype.show = function () {
            var that = this,
                is_exist = $.contains(document, that.$wrapper[0]);

            if (!is_exist) {
                that.$body.append(that.$wrapper);
            }

            that.$drawer_body.addClass(['animated', 'faster']);
            that.__assignPositionAnimation(that.$drawer_body);
            that.$wrapper.show();

            that.is_visible = true;
            that.is_removed = false;

            if (that.lock_body_scroll) {
                $.sa.scroll_locker.locked();
                that.$wrapper.addClass(that.class.body_locker);
            }

            that.custom_focus_class ?
                that.$wrapper.find(that.getSelector(that.custom_focus_class)).focus()
                : that.$drawer_body.attr('tabindex', -1).focus();
        };

        UIDrawer.prototype.close = function () {
            var that = this,
                result = null;

            if (that.is_visible && !that.is_removed) {
                //
                result = that.onClose(that);
                //
                if (result !== false) {
                    that.$drawer_background.hide();
                    that.__assignPositionAnimation(that.$drawer_body, false);
                    setTimeout(function () {
                        var visible_lockers_count = that.$body.find('.' + that.class.body_locker + ':visible').length;

                        that.$wrapper.remove();
                        if (that.lock_body_scroll && visible_lockers_count < 2) {
                            $.sa.scroll_locker.unlocked();
                        }
                        that.is_removed = true;
                    }, 350);
                }
            }

            return result;
        };

        UIDrawer.prototype.hide = function () {
            var that = this;

            that.__assignPositionAnimation(that.$drawer_body, false);
            setTimeout(function () {
                $('<div />').append(that.$wrapper.hide());

                that.is_visible = false;
                var visible_lockers_count = that.$body.find('.' + that.class.body_locker + ':visible').length;
                if (that.lock_body_scroll && visible_lockers_count < 2) {
                    $.sa.scroll_locker.unlocked();
                }
            }, 350);

        };

        UIDrawer.prototype.setBody = function (html) {
            var that = this;
            if (!html) {
                that.close();
                return;
            }
            that.$drawer_body.html(html);
            that.__initContentScrollbar();
            that.resize();
        }

        UIDrawer.prototype.setupContentHeight = function () {
            var that = this;

            that.__setupContentHeight();
        };

        //

        UIDrawer.prototype.getSelector = function (name) {
            var that = this;
            return (that.class[name] ? '.' + that.class[name] : null);
        }

        UIDrawer.prototype.__getWrapper = function () {
            var that = this,
                $result;

            if (that.options['html']) {
                $result = $(that.options['html']);
            } else if (that.options['$wrapper']) {
                $result = that.options['$wrapper'];
            } else {
                $result = getDrawer();
            }

            that.__assignPosition($result);
            that.__assignSize($result);

            if (!that.options['disable_content_scroll']) {
                var $content = $result.find('.' + that.class.content);
                $.uiScrollbar($content);
            }

            return $result;

            function getDrawer() {
                var result = false;

                // Build header
                var $header_wrapper = $('<div />').addClass(that.class.header_wrapper),
                    $header_title = $('<div />').addClass(that.class.header_title).append(that.options['header_title']),
                    $header_description = $('<div />').addClass(that.class.header_description).append(that.options['header_description']),
                    $header_close_icon = $('<a />').addClass(that.class.close_icon).addClass('js-close-drawer').attr('href', 'javascript:void(0);').append(that.icons.close);

                if (that.options['header_title']) {
                    $header_wrapper.append($header_title);
                }
                if (that.options['header_description']) {
                    $header_wrapper.append($header_description);
                }
                var $header_w = $('<div />')
                    .addClass(that.class.header)
                    .append($header_wrapper)
                    .append($header_close_icon);

                // Build content-fixed
                var $content_fixed = that.options['content_fixed'] ? $('<div />').addClass(that.class.content_fixed_wrapper).prepend(that.options['content_fixed']) : null,
                    $content_fixed_w = $content_fixed ? $('<div />').addClass(that.class.content_fixed).append($content_fixed) : null;

                // Build content
                var $content = that.options['content'] ? $('<div />').addClass(that.class.content).append(that.options['content']) : null,
                    $content_top = that.options['content_top'] ? $('<div />').addClass(that.class.content_top).prepend(that.options['content_top']) : null,
                    $content_w = $content ? $('<div />').addClass(that.class.content_wrapper).append($content) : null;

                // Build footer with buttons
                var $button_confirm = (that.options['button_confirm_text']) ? $('<button />').addClass('button').addClass('js-button-confirm').html(that.options['button_confirm_text']) : null,
                    $button_cancel = (that.options['button_cancel_text']) ? $('<button />').addClass('button').addClass('ghost').addClass('js-button-cancel').html(that.options['button_cancel_text']) : null;

                var $footer_w = $('<div />').addClass(that.class.footer),
                    $footer_content = (that.options['footer'] || null);

                if ($footer_content) {
                    $footer_w.append($footer_content);
                }
                if ($button_confirm) {
                    if (that.options['button_confirm_class']) {
                        $button_confirm.addClass(that.options['button_confirm_class']);
                    }
                    $footer_w.append($button_confirm);
                }
                if ($button_cancel) {
                    if (that.options['button_cancel_class']) {
                        $button_cancel.addClass(that.options['button_cancel_class']);
                    }
                    $footer_w.append($button_cancel);
                }

                // Build drawer
                var $wrapper = $('<div />').addClass(that.class.wrapper).addClass(that.class.body_locker),
                    $bg = $('<div />').addClass(that.class.background),
                    $body = $('<div />').addClass(that.class.body),
                    $layout = $('<div />').addClass(that.class.layout);

                if (that.mobile_fullscreen) {
                    $wrapper.addClass(that.class.wrapper_mobile_fullscreen);
                }

                if ($header_w || $content_fixed_w || $content_w || $footer_w) {
                    if ($header_w) {
                        if (that.header_contrast) {
                            $header_w.addClass(that.class.header_contrast);
                        }
                        $layout.append($header_w);
                    }
                    if ($content_fixed_w) {
                        $layout.append($content_fixed_w);
                    }
                    if ($content_w) {
                        $layout.append($content_w);
                    }
                    if ($footer_w) {
                        $layout.append($footer_w);
                    }
                    if (that.custom_class) {
                        $layout.addClass(that.custom_class);
                    }

                    $body.append($layout);
                    result = $wrapper.append($bg).append($body);

                    if ($content && !that.options['disable_content_scroll']) {
                        $.uiScrollbar($content);

                        if ($content_top) {
                            $content.prepend($content_top);
                        }
                    }
                }

                return result;
            }
        }

        UIDrawer.prototype.__initContentScrollbar = function () {
            var that = this;

            if (that.options['disable_content_scroll']) {
                return false;
            }

            var $block = (that.$drawer_body) ? that.$drawer_body : that.$wrapper,
                $content = $block.find(that.getSelector('content'));
            if (!$content.length) {
                return false;
            }

            var $content_scroll_wrapper = $content.parent('.scroll-wrapper');
            if (!$content_scroll_wrapper.length) {
                return false;
            }

            that.__setupContentHeight($content_scroll_wrapper);

            $.uiScrollbar($content);
        };

        UIDrawer.prototype.__setupContentHeight = function ($content_node = null) {
            var that = this;

            if (!$content_node || !$content_node.length) {
                var $block = (that.$drawer_body) ? that.$drawer_body : that.$wrapper,
                    $content = $block.find(that.getSelector('content'));
                if (!$content.length) {
                    return false;
                }
                $content_node = $content;
            }

            $content_node.removeAttr('style');

            var body_h = that.$wrapper.find(that.getSelector('body')).outerHeight() || 0,
                header_h = that.$wrapper.find(that.getSelector('header')).outerHeight() || 0,
                content_fixed_h = that.$wrapper.find(that.getSelector('content_fixed')).outerHeight() || 0,
                footer_h = that.$wrapper.find(that.getSelector('footer')).outerHeight() || 0,
                content_h = body_h - header_h - content_fixed_h - footer_h;

            $content_node.attr('style', 'max-height: ' + content_h + 'px !important');
        };

        UIDrawer.prototype.__assignPosition = function ($wrapper) {
            var that = this,
                position_class;

            switch (that.position) {
                case 'left':
                    position_class = that.class.position_left;
                    break;
                case 'right':
                    position_class = that.class.position_right;
                    break;
                case 'top':
                    position_class = that.class.position_top;
                    break;
                case 'bottom':
                    position_class = that.class.position_bottom;
                    break;
            }

            if (position_class) {
                $wrapper.addClass(position_class);
            }
            if (that.fluid === true) {
                $wrapper.addClass(that.class.fluid);
            }

            return position_class;
        }

        UIDrawer.prototype.__assignPositionAnimation = function ($drawer_body, is_show = true) {
            var that = this,
                class_show,
                class_hide;

            switch (that.position) {
                case 'left':
                    class_show = that.class.position_left_show;
                    class_hide = that.class.position_left_hide;
                    break;
                case 'right':
                    class_show = that.class.position_right_show;
                    class_hide = that.class.position_right_hide;
                    break;
                case 'top':
                    class_show = that.class.position_top_show;
                    class_hide = that.class.position_top_hide;
                    break;
                case 'bottom':
                    class_show = that.class.position_bottom_show;
                    class_hide = that.class.position_bottom_hide;
                    break;
            }

            if (is_show) {
                $drawer_body.removeClass(class_hide).addClass(class_show);
            } else {
                $drawer_body.removeClass(class_show).addClass(class_hide);
            }
        }

        UIDrawer.prototype.__assignSize = function ($wrapper) {
            var that = this,
                size_class,
                size_style;

            switch (that.size) {
                case 'extra-small':
                    size_class = that.class.size_extra_small;
                    break;
                case 'small':
                    size_class = that.class.size_small;
                    break;
                case 'large':
                    size_class = that.class.size_large;
                    break;
                case 'full':
                    size_class = that.class.size_full;
                    break;
            }

            if (['left', 'right'].includes(that.position)) {
                size_style = {width: that.size};
            }
            if (['top', 'bottom'].includes(that.position)) {
                size_style = {height: that.size};
            }

            if (size_class) {
                $wrapper.addClass(size_class);
            }

            if (size_style) {
                $wrapper.find(that.getSelector('body')).css(size_style);
            }
        }

        UIDrawer.prototype.__validateOptions = function () {
            var that = this;

            if (!that.AVAILABLE_POSITIONS.includes(that.position)) {
                throw 'Invalid position: ' + that.position;
            }
        }

        return UIDrawer;
    })($);

    $.uiDrawer = function (plugin_options) {
        plugin_options = (typeof plugin_options === 'object' ? plugin_options : {});
        var options = $.extend(true, {}, plugin_options);
        return new UIDrawer(options);
    };

})(jQuery);
